import type { ReactNode } from "react";

interface AuthLayoutProps {
  left: ReactNode;
  right: ReactNode;
}

// The two-pane chrome shared by login / signup / verify-email /
// reset-password pages: dark left with a specimen card, paper right with
// the form. Mirrors docs/mockups/login.html.
export function AuthLayout({ left, right }: AuthLayoutProps) {
  return (
    <main className="grid min-h-screen grid-cols-1 md:grid-cols-[1.05fr_1fr]">
      <section className="relative flex flex-col justify-between overflow-hidden bg-ink p-12 text-paper">
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background: `
              radial-gradient(circle at 80% 10%, rgba(180, 90, 57, 0.35), transparent 45%),
              radial-gradient(circle at 10% 90%, rgba(95, 106, 74, 0.25), transparent 50%)`,
          }}
        />
        <header className="relative flex items-baseline gap-3">
          <span className="font-display text-2xl tracking-[-0.04em] text-paper [font-variation-settings:'opsz'_96,'SOFT'_80,'WONK'_1,'wght'_500]">
            Varo
          </span>
          <span className="ml-1 text-[11px] font-mono uppercase tracking-[0.18em] text-paper/55">
            A card without paper
          </span>
        </header>
        <div className="relative">{left}</div>
        <footer className="relative flex items-baseline justify-between text-[11px] font-mono uppercase tracking-[0.18em] text-paper/45">
          <span>Est. varo.biz</span>
          <span>Sign in →</span>
        </footer>
      </section>
      <section className="flex items-center justify-center bg-paper p-12">
        <div className="w-full max-w-md">{right}</div>
      </section>
    </main>
  );
}
